import type { Picture } from "imagetools-core";

export interface Input {
  image: Picture;
  alt: string;
  sizes?: string;
  class?: string;
  imgClass?: string;
  loading?: "eager" | "lazy";
  decoding?: "async" | "auto" | "sync";
  fetchpriority?: "high" | "low" | "auto";
}

picture class=[styles.picture, input.class]
  for|[format, srcset]| of=Object.entries(input.image.sources)
    source type=`image/${format}` srcset=srcset sizes=input.sizes
  img
    ,src=input.image.img.src
    ,width=input.image.img.w
    ,height=input.image.img.h
    ,alt=input.alt
    ,class=[styles.image, input.imgClass]
    ,loading=input.loading
    ,decoding=input.decoding
    ,fetchpriority=input.fetchpriority

style/styles
  --

    .picture,
    .image {
      display: block;
    }

    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
